import Calculation from "./components/Calculation/Calculation";
import Footer from "./components/Footer/Footer";
import Header from "./components/Header/Header";

function App() {
	return (
		<>
			<main className="section-wrapper">
				<Header />
				<Calculation />
				<Footer />
			</main>
		</>
	);
}

export default App;
